import { cn } from "@/lib/utils";
import Icon, { IconIdType } from "@/components/ui/Icon";
import { memo } from "react";
import { Typography } from "@/components/ui/typography";

export type SecurityCardProps = {
  title?: string;
  description: string;
  iconId: IconIdType;
} & React.ComponentProps<"div">;

const SecurityCard = ({
  iconId,
  title,
  description,
  className,
}: SecurityCardProps) => {
  return (
    <div
      className={cn(
        "flex p-5 border bg-white border-neutral-200 rounded-3xl overflow-hidden lg:rounded-2xl md:border-transparent",

        className
      )}
    >
      <div className="flex-auto min-w-0 flex flex-col items-start gap-3">
        <Icon
          id={iconId}
          className="shrink-0 text-blue-500 w-12 h-12 md:w-8 md:h-8"
        />
        <div className="grid grid-cols-1 gap-3 place-content-start md:gap-2">
          <Typography
            variant="titleMd"
            className="text-semantic-text-primary font-semibold md:text-gray-800 md:text-xl md:leading-[150%] lg:text-gray-800"
            asChild
          >
            <h3>{title}</h3>
          </Typography>
          <div className="text-semantic-text-secondary text-base leading-[160%] md:leading-[150%] lg:text-gray-600">
            <p>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SecurityCard);
